import "@arco-design/web-react/es/Carousel/style";
import _Carousel from "@arco-design/web-react/es/Carousel";
import React from 'react';
import locale from './locale';
import styles from './style/index.module.less';
import useTranslation from '@/utils/useTranslation';
export default function LoginBanner() {
  const t = useTranslation(locale);
  const data = [
  // {
  //   slogan: t['login.banner.slogan1'],
  //   subSlogan: t['login.banner.subSlogan1'],
  //   image:
  //     'http://www.ahhsstd.com/static/upload/image/20240724/1721790170424884.jpg',
  // },
  // {
  //   slogan: t['login.banner.slogan2'],
  //   subSlogan: t['login.banner.subSlogan2'],
  //   image:
  //     'http://www.ahhsstd.com/static/upload/image/20240724/1721790157109380.jpg',
  // },
  // {
  //   slogan: t['login.banner.slogan3'],
  //   subSlogan: t['login.banner.subSlogan3'],
  //   image:
  //     'http://www.ahhsstd.com/static/upload/image/20240724/1721790183494105.jpg',
  // },
  {
    slogan: t['login.banner.slogan3'],
    subSlogan: t['login.banner.subSlogan3'],
    image: '/static/imgs/a1.jpg'
  }, {
    slogan: t['login.banner.slogan3'],
    subSlogan: t['login.banner.subSlogan3'],
    image: '/static/imgs/a2.jpg'
  }, {
    slogan: t['login.banner.slogan3'],
    subSlogan: t['login.banner.subSlogan3'],
    image: '/static/imgs/a3.jpg'
  }];
  return /*#__PURE__*/React.createElement(_Carousel, {
    className: styles.carousel,
    animation: "fade"
  }, data.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: `${index}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-item']
  }, /*#__PURE__*/React.createElement("img", {
    alt: "banner-image",
    className: styles['carousel-image'],
    src: item.image
  })))));
}